export const getOperatingPeriodTableData = (
  temperatureData: { [key: number]: number },
  monthStatus: {
    [key: string]: { index: number; name: string; value: boolean };
  },
  season: string
) => {
  const header = [
    [
      {
        content: `Operating Period for the Heat Pump`,
        colSpan: 12,
        styles: {
          halign: "left" as const,
          fillColor: [255, 210, 0] as [number, number, number],
          textColor: 0,
          fontStyle: "bold" as const,
          font: "NotoSans-Regular",
        },
      },
    ],
    [
      {
        content: `${season}`,
        colSpan: 12,
        styles: {
          halign: "left" as const,
          textColor: 0,
          fillColor: [255, 255, 255] as [number, number, number],
          fontStyle: "bold" as const,
          font: "NotoSans-Bold",
        },
      },
    ],
  ];
  const getSymbol = (value: boolean): string => {
    return value ? "\u2714" : "\u2718";
  };

  const getTextColor = (value: boolean): [number, number, number] => {
    return value ? [0, 128, 0] : [255, 0, 0]; 
  };

  const footer = [
    [
      {
        content: `Season: ${season}`,
        colSpan: 12,
        styles: {
          halign: "left" as const,
          textColor: 0,
          fillColor: [255, 255, 255] as [number, number, number],
          fontStyle: "bold" as const,
          font: "NotoSans-Regular",
        },
      },
    ],
  ];

  const rows = [
    [
      {
        content: `Jan\n${temperatureData[1]}°C`,
        styles: {
          halign: "center" as const,
          valign: "middle" as const,
          cellWidth: 15.15,
          lineHeight: 1.2,
        },
      },
      {
        content: `Feb\n${temperatureData[2]}°C`,
        styles: {
          halign: "center" as const,
          valign: "middle" as const,
          cellWidth: 15.15,
          lineHeight: 1.2,
        },
      },
      {
        content: `Mar\n${temperatureData[3]}°C`,
        styles: {
          halign: "center" as const,
          valign: "middle" as const,
          cellWidth: 15.15,
          lineHeight: 1.2,
        },
      },
      {
        content: `Apr\n${temperatureData[4]}°C`,
        styles: {
          halign: "center" as const,
          valign: "middle" as const,
          cellWidth: 15.15,
          lineHeight: 1.2,
        },
      },
      {
        content: `May\n${temperatureData[5]}°C`,
        styles: {
          halign: "center" as const,
          valign: "middle" as const,
          cellWidth: 15.15,
          lineHeight: 1.2,
        },
      },
      {
        content: `Jun\n${temperatureData[6]}°C`,
        styles: {
          halign: "center" as const,
          valign: "middle" as const,
          cellWidth: 15.15,
          lineHeight: 1.2,
        },
      },
      {
        content: `Jul\n${temperatureData[7]}°C`,
        styles: {
          halign: "center" as const,
          valign: "middle" as const,
          cellWidth: 15.15,
          lineHeight: 1.2,
        },
      },
      {
        content: `Aug\n${temperatureData[8]}°C`,
        styles: {
          halign: "center" as const,
          valign: "middle" as const,
          cellWidth: 15.15,
          lineHeight: 1.2,
        },
      },
      {
        content: `Sep\n${temperatureData[9]}°C`,
        styles: {
          halign: "center" as const,
          valign: "middle" as const,
          cellWidth: 15.15,
          lineHeight: 1.2,
        },
      },
      {
        content: `Oct\n${temperatureData[10]}°C`,
        styles: {
          halign: "center" as const,
          valign: "middle" as const,
          cellWidth: 15.15,
          lineHeight: 1.2,
        },
      },
      {
        content: `Nov\n${temperatureData[11]}°C`,
        styles: {
          halign: "center" as const,
          valign: "middle" as const,
          cellWidth: 15.15,
          lineHeight: 1.2,
        },
      },
      {
        content: `Dec\n${temperatureData[12]}°C`,
        styles: {
          halign: "center" as const,
          valign: "middle" as const,
          cellWidth: 15.15,
          lineHeight: 1.2,
        },
      },
    ],
    [
      {
        content: getSymbol(monthStatus.jan.value),
        styles: {
          halign: "center" as const,
          valign: "top" as const,
          cellWidth: 15.15,
          cellPadding: -1.5,
          font: "NotoSansSymbols2-Regular",
          fontSize: 12,
          textColor: getTextColor(monthStatus.jan.value),
        },
      },
      {
        content: getSymbol(monthStatus.feb.value),
        styles: {
          halign: "center" as const,
          valign: "top" as const,
          cellWidth: 15.15,
          cellPadding: -1.5,
          font: "NotoSansSymbols2-Regular",
          fontSize: 12,
          textColor: getTextColor(monthStatus.feb.value),
        },
      },
      {
        content: getSymbol(monthStatus.mar.value),
        styles: {
          halign: "center" as const,
          valign: "top" as const,
          cellWidth: 15.15,
          cellPadding: -1.5,
          font: "NotoSansSymbols2-Regular",
          fontSize: 12,
          textColor: getTextColor(monthStatus.mar.value),
        },
      },
      {
        content: getSymbol(monthStatus.apr.value),
        styles: {
          halign: "center" as const,
          valign: "top" as const,
          cellWidth: 15.15,
          cellPadding: -1.5,
          font: "NotoSansSymbols2-Regular",
          fontSize: 12,
          textColor: getTextColor(monthStatus.apr.value),
        },
      },
      {
        content: getSymbol(monthStatus.may.value),
        styles: {
          halign: "center" as const,
          valign: "top" as const,
          cellWidth: 15.15,
          cellPadding: -1.5,
          font: "NotoSansSymbols2-Regular",
          fontSize: 12,
          textColor: getTextColor(monthStatus.may.value),
        },
      },
      {
        content: getSymbol(monthStatus.jun.value),
        styles: {
          halign: "center" as const,
          valign: "top" as const,
          cellWidth: 15.15,
          cellPadding: -1.5,
          font: "NotoSansSymbols2-Regular",
          fontSize: 12,
          textColor: getTextColor(monthStatus.jun.value),
        },
      },
      {
        content: getSymbol(monthStatus.jul.value),
        styles: {
          halign: "center" as const,
          valign: "top" as const,
          cellWidth: 15.15,
          cellPadding: -1.5,
          font: "NotoSansSymbols2-Regular",
          fontSize: 12,
          textColor: getTextColor(monthStatus.jul.value),
        },
      },
      {
        content: getSymbol(monthStatus.aug.value),
        styles: {
          halign: "center" as const,
          valign: "top" as const,
          cellWidth: 15.15,
          cellPadding: -1.5,
          font: "NotoSansSymbols2-Regular",
          fontSize: 12,
          textColor: getTextColor(monthStatus.aug.value),
        },
      },
      {
        content: getSymbol(monthStatus.sep.value),
        styles: {
          halign: "center" as const,
          valign: "top" as const,
          cellWidth: 15.15,
          cellPadding: -1.5,
          font: "NotoSansSymbols2-Regular",
          fontSize: 12,
          textColor: getTextColor(monthStatus.sep.value),
        },
      },
      {
        content: getSymbol(monthStatus.oct.value),
        styles: {
          halign: "center" as const,
          valign: "top" as const,
          cellWidth: 15.15,
          cellPadding: -1.5,
          font: "NotoSansSymbols2-Regular",
          fontSize: 12,
          textColor: getTextColor(monthStatus.oct.value),
        },
      },
      {
        content: getSymbol(monthStatus.nov.value),
        styles: {
          halign: "center" as const,
          valign: "top" as const,
          cellWidth: 15.15,
          cellPadding: -1.5,
          font: "NotoSansSymbols2-Regular",
          fontSize: 12,
          textColor: getTextColor(monthStatus.nov.value),
        },
      },
      {
        content: getSymbol(monthStatus.dec.value),
        styles: {
          halign: "center" as const,
          valign: "top" as const,
          cellWidth: 15.15,
          cellPadding: -1.5,
          font: "NotoSansSymbols2-Regular",
          fontSize: 12,
          textColor: getTextColor(monthStatus.dec.value),
        },
      },
    ],
  ];

  return { header, rows, footer };
};
